import script from "./topMenuNav.vue?vue&type=script&setup=true&lang=js"
export * from "./topMenuNav.vue?vue&type=script&setup=true&lang=js"

import "./topMenuNav.vue?vue&type=style&index=0&id=1c54b740&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c54b740"]])

export default __exports__